var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ol",
    {
      staticClass: "stepper",
      attrs: { "aria-label": _setup.t("contestEntryForm.steps.ariaLabel") },
    },
    _vm._l(_setup.steps, function (step) {
      return _c(
        "li",
        {
          key: step.id,
          staticClass: "step",
          class: { active: step.id === _vm.currentStep },
        },
        [
          _c(
            "span",
            {
              staticClass: "step-badge",
              class: { active: step.id === _vm.currentStep },
            },
            [_vm._v(_vm._s(step.id))]
          ),
          _c("span", { staticClass: "step-label" }, [
            _vm._v(_vm._s(step.label)),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }